import TBUploadManager from './TBUploadManager';
import TBUploadManagerConnector from './TBUploadManagerConnector';

const ConnectedComponent = () => <TBUploadManagerConnector component={TBUploadManager} />;

export default ConnectedComponent;
